module.exports = __webpack_public_path__ + "static/media/logo_newstomato.cbc43329.png";